import Fuse, { type IFuseOptions } from "fuse.js";

import type { WatchlistJob } from "./JobSalary.dto";
import type { JobSalary } from "./JobSalary.model";
import type { Quantile } from "./watchlist.filters";

export const QUANTILE_MAP = {
  "<1y": {
    min: 0,
    max: 1,
  },
  "1-5y": {
    min: 1,
    max: 5,
  },
  "5-10y": {
    min: 5,
    max: 10,
  },
  "10-15y": {
    min: 10,
    max: 15,
  },
  ">15y": {
    min: 15,
    max: 50,
  },
} as const;

export type QuantileKey = keyof typeof QUANTILE_MAP;

/**
 * Gets the minimum or maximum value for a given quantile
 * @param selectedQuantile - The selected quantile option
 * @param type - Whether to get the "min" or "max" value
 * @returns The quantile boundary value, or undefined if not found
 */
export const getQuantile = (selectedQuantile: Quantile | null, type: "min" | "max"): number | undefined => {
  if (!selectedQuantile?.short) {
    return undefined;
  }

  const quantile = QUANTILE_MAP[selectedQuantile.short as QuantileKey];
  return type === "min" ? quantile?.min : quantile?.max;
};

function createFuseSearch<T>(items: T[], options: IFuseOptions<T>): (search: string) => T[] {
  const fuseJobSearch = new Fuse(items, options);
  return (search: string) => {
    const results = fuseJobSearch.search(search);
    return results.map((result) => result.item);
  };
}

export function createFuseSearchWatchlistJob(allJobs: WatchlistJob[]): (search: string) => WatchlistJob[] {
  return createFuseSearch(allJobs, {
    keys: ["jobTitle", "jobTitleAliases"],
    threshold: 0.3,
  });
}

export function createFuseSearchJobSalary(allJobSalaries: JobSalary[]): (search: string) => JobSalary[] {
  return createFuseSearch(allJobSalaries, {
    keys: ["title", "titleAliases"],
    threshold: 0.3,
  });
}
